'use strict';

angular
	.module('upResources', ['ngResource', 'security', 'config'])
	.constant('settings', {})
	.config(['$httpProvider', function ($httpProvider) {}]);
